import { useContext } from 'react';
import { ConfigContext } from '@/from-theme/contexts/ConfigContext';

// ==============================|| CONFIG - HOOKS ||============================== //

const useConfig = () => useContext(ConfigContext);

export default useConfig;
